import { UserSettings } from 'src/types/UserSettings';
import { CountriesEnum, LocalesEnum, RegionsEnum } from 'src/generated/operations';

export const defaultUserSettings: UserSettings = {
  currentLocale: LocalesEnum.EnGb,
  currentRegion: RegionsEnum.Eu,
  currentCountry: CountriesEnum.Ch
}
